import JwtDecode from "jwt-decode";

export default class User {
  static from(object) {
    try {
      return new User(object);
    } catch (err) {
      console.log("error - no user");
      return err;
    }
  }

  constructor(initializer) {
    this.id = initializer.school_id
    this.name = initializer.name;
    this.school = initializer.school;
    this.type = initializer.school_type;
    this.style = initializer.style;
    this.role = initializer.role
    this.admin = initializer.is_admin
    this.userType = initializer.user_type;
    this.teacherId = initializer.teacher_id
    this.userIdentifier = initializer.identifier
    this.expiryDate = initializer.expiration_date
  }

  setAdmin(value) {
    this.admin = value
  }

  get schoolID() {
    return this.id;
  }

  get teacherID() {
    return parseInt(this.teacherId)
  }

  get teacherIdentifier() {
    return this.userIdentifier
  }

  get teacherName() {
    return this.name
  }

  get schoolName() {
    return this.school;
  }

  get schoolType() {
    return this.type;
  }
  
  get userRole() {
    return this.role;
  }

  get isSubscriber() {
    return this.type != "trial" && this.type != "free";
  }

    get isOnLite() {
    return this.type === "lite"
  }


  get isOnFree() {
    return this.type === "free"
  }

  get isOnSEN() {
    return this.type === "sen"
  }

   get isOnDance() {
    return this.type === "dance"
  }

  get isOnTrial() {
    return this.type === 'trial';
  }

  get hasAdmin() {
    return this.admin === true
  }

  get isContentAdmin() {
    return this.userType === "contentadmin";
  }

  get typeID() {
    return this.type == "organisation" ? 4 : 3;
  }

  get isSchool() {
    return this.type != "organisation";
  }

  get isOrganisation() {
    return this.isSchool === false;
  }

  get schoolStyle() {
    return this.style;
  }

  get isSecondaryBased() {
    return ["secondary", "international"].includes(this.userType)
  }

  get isConsul() {
    return this.isSchool === true && this.style.length > 1
  }

  get authIsExpired() {
    var now = new Date();
    var expiry = new Date(this.expiryDate);
    return this.type == "expired" || (this.type == "trial" && (now > expiry))
   }

  get schoolBackground() {
    switch (this.type) {
      case "secondary": 
      return "secondary-blue";
      break;
      case "gcse": 
      return "gcse-teal";
      break;
      case "international": 
      return "international-purple";
      break;
      default:
      return "pink-red";
    }
    
  }

  get schoolLogo() {
      switch (this.type) {
      case "secondary": 
      return "secondary-passport-logo";
      break;
      case "gcse": 
      return "gcse-passport-logo";
      break;
      case "international": 
      return "secondary-passport-logo";
      break;
      default:
      return "primary-passport-logo";
    }
  }

}
